var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:[("cell-value-" + _vm.col)]},[_vm._v("\n  "+_vm._s(_vm.entry[_vm.col])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }